export const blockIconsMapsPersonPinCircleNew = (
	<span className='material-symbols-outlined'>person_pin_circle</span>
);
